import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  simpleBox: {
    padding: '20px 15px',
    display: 'flex',
    height: 175,
    justifySelf: 'stretch',
    justifyContent: 'space-between',
    backgroundColor: '#FFF',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  flexDirectionColumn: {
    flexDirection: 'column',
  },
  simpleBoxWithImage: {
    [theme.breakpoints.down('xs')]: {
      height: 'auto !important',
    },
  },
  boxText: {
    fontSize: '1rem',
  },
  boxTextFlex: {
    fontSize: '1rem',
    display: 'flex',
    '& > svg': {
      marginRight: 10,
    },
  },
  boxHeader: {
    fontSize: '1.2rem',
    marginTop: 10,
    color: theme.palette.primary.main,
  },
  boxNumber: {
    fontSize: '3rem',
  },
  flexDirectionColumnXs: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column !important',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  texts: {
    width: 'auto',
  },
  textsCentered: {
    width: '100%',
    margin: 'auto 0',
  },
  imgContainer: {
    width: '40%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      height: '50%',
      width: '100%',
    },
  },
  img: {
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
  },
}));

const SimpleBox = ({ gridArea, data, column }) => {
  const classes = useStyles();

  return (
    <Box
      className={clsx(
        classes.simpleBox,
        data.filter((elem) => elem.image).length > 0 &&
          classes.simpleBoxWithImage,
        column && classes.flexDirectionColumn,
      )}
      style={{
        gridArea: gridArea,
      }}
      boxShadow={3}
    >
      {data.map((elem) => (
        <div
          className={
            elem.image
              ? clsx(classes.container, classes.flexDirectionColumnXs)
              : classes.container
          }
        >
          <div className={elem.centerTexts ? classes.textsCentered : classes.texts}>
            {elem.title && (
              <p
                className={
                  elem?.titleHeader ? classes.boxHeader : classes.boxText
                }
              >
                {elem.title}
              </p>
            )}
            {elem.value && <p className={classes.boxNumber}>{elem.value}</p>}
            {elem.text && (
              <p className={elem.icon ? classes.boxTextFlex : classes.boxText}>
                {elem.icon}
                {elem.text}
              </p>
            )}
            {elem.chip}
          </div>
          {elem.image && (
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={elem.image}
                alt={elem.alt ?? 'image'}
              />
            </div>
          )}
        </div>
      ))}
    </Box>
  );
};

SimpleBox.propTypes = {
  gridArea: PropTypes.string.isRequired,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  column: PropTypes.bool,
};

SimpleBox.defaultProps = {
  column: false,
};

export default SimpleBox;
